<template>
  <div>
    <h1>搜索条件</h1>
    <el-form :model="searchForm" label-width="80px">
      <el-form-item label="结束时间">
        <el-date-picker v-model="searchForm.end_time" type="month" format="yyyy-MM" value-format="yyyy-MM"></el-date-picker>
      </el-form-item>
    </el-form>
    <el-button type="primary" @click="search">搜索</el-button>
    <el-divider></el-divider>
    <h2>搜索结果</h2>
    <el-table :data="searchResult" border>
      <el-table-column v-for="(field, index) in selectedFields" :key="index" :prop="field.prop" :label="field.label"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      searchForm: {
        end_time: ''
      },
      searchResult: [],
      selectedFields: [
        { prop: 'processTitle', label: '工单标题' },
        { prop: 'instanceStatus', label: '当前状态' },
        { prop: 'pullOutTime', label: '拔/盘卡完成时间' },
        { prop: 'socDispatchTime', label: '起单时间' },
        { prop: 'checkPointTime', label: '当前状态写入时间' },
        { prop: 'olaTime', label: '超时时间' },
        { prop: 'ProcessUsers', label: '当前处理人' },
        { prop: 'amount', label: '每单总台数' },
        { prop: 'campus', label: '园区' },
        { prop: 'idcName', label: '机房单元' },
        { prop: 'idcpName', label: '一级机房' },
        { prop: 'requestId', label: '上游实例id' },
        { prop: 'ticketId', label: 'DCOPS单号' },
        { prop: 'supplierName', label: '服务商名称' },
        { prop: 'supplierContactName', label: '服务商联系人' }
      ]
    }
  },
  methods: {
    search() {
      const payload = {
        end_time: this.searchForm.end_time
      };
      axios.post('/api/v1/ops/get_retire_info', payload)
      .then(response => {
        this.searchResult = response.data.data;
      })
      .catch(error => {
        console.error(error);
      });
    }
  }
}
</script>